import { TemplateHistoryApiResultObject } from "./TemplateHistoryApiResult";
import { ContractNameNumber, CustomerNameId, ItemNameNumber } from "./TemplateMetadataModels";

export type ItemFloatTemplateHistoryApiResultObject = 
    TemplateHistoryApiResultObject & 
    ItemFloatTemplateHistoryMetadata;

export type ItemFloatTemplateHistoryMetadata = {
    Customers: CustomerNameId[] | null,
    Items: ItemNameNumber[] | null,
    Contracts: ContractNameNumber[] | null
}

export const ItemFloatTemplateHeaderRows_AoA = [
    [
        "Customer Number",
        "Shipto",
        "Name",
        "Item Number",
        "Description",
        "Manufacturer",
        "Contract Number",
        "Contract Name",
        "Price",
        "UOM",
        "Begin Date",
        "End Date",
        "Employee",
        "Job Type",
        "Supplier Responsible",
        "Comments",
        "Promo Flag",
        "Adj Y/N",
        "Auto Adj Y/N",
        "Adj Type",
        "Adj Amt",
        "Adj %",
    ]
];
